import React from 'react';

export function EditIcon({ size = 7 }: { size?: number }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			strokeWidth={1.5}
			stroke="currentColor"
			className={`w-${size} h-${size}`}
		>
			<path
				strokeLinecap="round"
				strokeLinejoin="round"
				d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
			/>
		</svg>
	);
}

export function RightArrowIcon() {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.333374 9.40885H14.722V8.74219H0.333374V9.40885Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.23769 15.7872L7.76636 15.3159L14.0057 9.07657L7.76636 2.83657L8.23769 2.36523L14.9484 9.07657L8.23769 15.7872Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.1348 17.818H17.8014V0.333984H17.1348V17.818Z"
				fill="currentColor"
			/>
		</svg>
	);
}

export function LeftArrowIcon() {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="currentColor"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.333374 9.0759L7.04404 15.7872L7.51604 15.3152L1.60937 9.40924H14.9487V8.74257H1.60937L7.51604 2.83657L7.04404 2.36523L0.333374 9.0759Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.2727 17.818H17.9394V0.333984H17.2727V17.818Z"
				fill="currentColor"
			/>
		</svg>
	);
}
